import { render, staticRenderFns } from "./TheRecoverPassword.vue?vue&type=template&id=3f9aa4f2&scoped=true"
import script from "./TheRecoverPassword.vue?vue&type=script&lang=js"
export * from "./TheRecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./TheRecoverPassword.vue?vue&type=style&index=0&id=3f9aa4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9aa4f2",
  null
  
)

export default component.exports